<section>
  <h3 class="text-3 bold-1">{{ header() }}</h3>
  <p class="text-4">{{ subtitle() }}</p>
  <a routerLink="/projects">See our projects →</a>
</section>

<section>
  <ng-content />
</section>
